"use client";

import { motion } from "framer-motion";
import { brand } from "@/lib/colors";

export default function LoadingComponent() {
  return (
    <div className="z-50 flex h-screen w-full items-center justify-center bg-white/95 backdrop-blur-sm">
      <div className="flex flex-col items-center space-y-8">
        {/* <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="relative"
        >
        <motion.div
            animate={{
              scale: [1, 1.05, 1],
              rotate: [0, 1, -1, 0],
            }}
            transition={{
              duration: 3,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut",
            }}
          >
            <Image
              src="/hallasheri.png"
              alt="Loading"
              width={120}
              height={120}
              className="rounded-2xl shadow-lg"
            />
          </motion.div>

        <motion.div
            className="absolute inset-0 rounded-2xl border-2 border-blue-400"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 0, 0.5],
            }}
            transition={{
              duration: 2,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut",
            }}
          />
           </motion.div> */}

        <div className="text-center">
          <motion.div
            className="text-3xl font-bold text-gray-800 md:text-4xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {"Halla Sheri".split("").map((char, index) => (
              <motion.span
                key={index}
                className="inline-block"
                animate={{
                  y: [0, -10, 0],
                  color: [brand[800], brand[500], brand[800]],
                  // color: ["#1f2937", "#3b82f6", "#1f2937"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                  delay: index * 0.1,
                  ease: "easeInOut",
                }}
              >
                {char === " " ? "\u00A0" : char}
              </motion.span>
            ))}
          </motion.div>
        </div>

        <motion.div
          className="h-1 w-64 overflow-hidden rounded-full bg-gray-200"
          initial={{ opacity: 0, width: 0 }}
          animate={{ opacity: 1, width: 256 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <motion.div
            className="from-brand-400 to-brand-600 h-full rounded-full bg-gradient-to-r"
            animate={{
              x: [-256, 256],
            }}
            transition={{
              duration: 1.5,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut",
            }}
          />
        </motion.div>
      </div>
    </div>
  );
}
